import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Header from '../../components/Header';

import ProjectTypesNav from '../ProjectTemplatesContainer/ProjectTypesNav';

import styles from '../../assets/styles/globals.scss';
import addIcon from '../../assets/images/add-icon-gray.svg';
import ProjectTypesIcon from '../../components/Iconoclast/ProjectTypesIcon';
import './ProjectTypesContainer.scss';

export class ProjectTypesContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };

    this.handleFinishedLoading = this.handleFinishedLoading.bind(this);
  }

  componentDidMount() {
    if(this.props && this.props.permissions){
      this.uneditedTemplateEditPermissions = this.props.permissions.canEditProjectTemplate;
      this.uneditedProjectEditPermissions = this.props.permissions.canEditProject;
    }
  }

  componentDidUpdate(prevProps, prevState) {
  }

  handleFinishedLoading(projectTypesCount) {
    this.setState({ finishedLoading: true, projectTypesCount });
  }

  render() {

    const { finishedLoading, projectTypesCount } = this.state;
    let header = <Header selectedPage="project-types" />;

    const path = this.props.history.parseParameters();

    const paramsString = path.params.project_id + (path.params.build_id ? path.params.build_id : '') + (path.params.task_id ? path.params.task_id : '');
    
    let emptyContent = null;
    if (finishedLoading && projectTypesCount == 0) {
      emptyContent = <div className="project_types_empty">
        <div className="project_types_empty__text">
          There are no Project Types created.<br/>
          Select <img className='project-types-add-button' alt='button' onClick={this.handleAddProjectTemplateButtonClicked} src={addIcon} /> to add a Project Type.
        </div>
      </div>;
    } else if (finishedLoading && !path.params.project_template_id) {
      emptyContent = <div className="project_types_empty">
        <div className="project_types_empty__icon">
          <ProjectTypesIcon iconColor={styles.warmGreyTwo}/>
        </div>
        <div className="project_types_empty__text">
          To view/edit Project Templates, you must first select a Version.
        </div>
      </div>;
    } 
    return (
      <div className="project_types_container"
        ref={(element) => { this.mainContainer = element; }}>
        {this.props.systemPopup}
        {header}
        <div className="project_types_body">
          <ProjectTypesNav
            history={this.props.history}
            path={path}
            selectedCompany={this.props.currentCompany}
            animateExpand={this.state.animateActionCable}
            addButton={false}
            clearButton={this.handleClearAddButtonClicked}
            markets={this.state.markets}
            projectTypes={this.state.projectTypes}
            handleProjectTypeAdd={this.handleProjectTypeAdd}
            handleDeleteType={this.handleProjectTypeDelete}
            handleAddProjectTemplate={this.handleAddProjectTemplate}
            handleFinishedLoading={this.handleFinishedLoading}
          />
          <div className="project_types_detail" id="project-types-detail-container" >
            {emptyContent ||
            <Router history={this.props.history}>
            <Switch>
              {this.props.routes.map((route, i) => (
                <Route
                  key={route.component.displayName ? route.component.displayName : route.component.name}
                  path={route.path}
                  render={props => {
                    let routeProps = { ...props };
                    routeProps.params = path.params;
                    routeProps.id = paramsString;
                    routeProps.key = paramsString;
                    routeProps.history = this.props.history;

                    if (path.params.project_id && path.params.edit) {
                      routeProps.isDialog = true;
                      routeProps.handleSaveProject = this.handleSaveProject;
                    }
                    return (
                      <route.component {...routeProps} routes={route.routes} />
                    );
                  }
                  }
                />
              )
              )}
            </Switch>
          </Router>
          }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany || null,
    currentUser: state.new_users.currentUser || null,
    permissions: state.new_users.permissions || null,
    inProgress: state.main.inProgress,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectTypesContainer));



// WEBPACK FOOTER //
// ./src/containers/ProjectTypesContainer/index.js